import React, { useCallback } from 'react'
import { TreeSelect } from 'antd'
import { isUndefined, noop } from 'lodash'
import PropTypes from 'prop-types'

import { SIZES } from '../../constants'
import { handleTreeSelectDropdownSearchHighlights } from '../../helpers'
import { antFormItemNamePropType } from '../../prop-types'

const ListItemTreeSelect = ({
  name,
  treeData,
  onChange,
  shouldModify,
  value,
  onClear,
  treeNodeLabelProp,
  ...rest
}) => {
  const handleOnChange = useCallback(
    value => {
      if (isUndefined(value)) {
        onClear(name)
        return
      }

      if (shouldModify(value)) {
        onChange(value)
      }
    },
    [name, onChange, onClear, shouldModify],
  )

  return (
    <TreeSelect
      onChange={handleOnChange}
      value={value}
      dropdownMatchSelectWidth={SIZES.DROPDOWN_MIN_WIDTH}
      dropdownRender={handleTreeSelectDropdownSearchHighlights}
      treeData={treeData}
      treeNodeFilterProp="title"
      treeNodeLabelProp={treeNodeLabelProp}
      {...rest}
    />
  )
}

ListItemTreeSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  shouldModify: PropTypes.func.isRequired,
  name: antFormItemNamePropType.isRequired,
  treeData: PropTypes.array.isRequired,
  onClear: PropTypes.func.isRequired,
  treeNodeLabelProp: PropTypes.string,
}

ListItemTreeSelect.defaultProps = {
  value: undefined,
  treeNodeLabelProp: 'title',
  onChange: noop,
}

export default ListItemTreeSelect
